<template>
  <div class="avecor-table" style="position:fixed; bottom:0px; z-index:100; background:#eee; border:1px solid #ccc; max-height:400px;">
  
    <div style="position:absolute; left:10px; top:10px;">
      <v-icon 
        class="avecor-table-actions"
        :size="16"
        style="padding-right:10px"
        @click="selectedWholesaleCompanyId=null;"
      >
        far fa-window-close
      </v-icon>
      
          
    </div>
    <v-row no-gutters justify-center class="pt-2 pb-2">
      <v-col cols="12" class="text-center" style="font-size:24px;">
        {{wholesaleCompanies[selectedWholesaleCompanyId].name}}
      </v-col>
    </v-row>
    
    <v-tabs
      style="padding-top:0px;"
      fixed-tabs
      dark
      dense
      height="30"
      background-color="#136DF5"
      v-model="selectedWholesaleCompanyTab"
    >
    
      <v-tabs-slider color="#FFF"></v-tabs-slider>
      <v-tab href="#details" >Tiedot</v-tab>
      <v-tab href="#contacts" >Kontaktit</v-tab>
      <v-tab-item value="details" class="product-details-view-tab-item">
        <v-row no-gutters class="mt-2 pl-5 pr-5">
            <v-col cols="5">
              <v-row no-gutters>
                <v-col cols="3">
                  <v-text-field
                    label="Lisätty pvm"
                    slot="activator"
                    :disabled="true"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].created_at ? customFormatter(wholesaleCompanies[selectedWholesaleCompanyId].created_at) : ''"
                    readonly
                    filled
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="3">
                  <v-text-field
                    label="Avecor koodi"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].wholesaleCode"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'wholesaleCode',v)"
                    class="ml-3"
                    filled
                  ></v-text-field>
                </v-col> -->
                <v-col cols="3">
                  <v-text-field
                    class="ml-3"
                    label="Tukkurin nimi"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].name"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'name',v)"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Kieli"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].language"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'language',v)"
                    class="ml-3"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Verkkosivuosoite"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].webAddress"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'webAddress',v)"
                    class="ml-3"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Verkkosivuosoite 2"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].webAddress2"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'webAddress2',v)"
                    class=""
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Käyttäjätunnus"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].username"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'username',v)"
                    class="ml-3"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    label="Salasana"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].password"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'password',v)"
                    class="ml-3"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    label="Miten tilaus?"
                    autocomplete="off"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].orderStyle"
                    :items="settings.wholesalesOrderStyles"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'orderStyle',v)"
                    item-text="fi"
                    item-value="id"
                    persistent-hint
                    class="ml-3"
                    filled
                  />
                </v-col>
                <v-col cols="6">
                  <v-textarea
                    label="Tilaussähköposti"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].orderEmail"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'orderEmail',v)"
                    class=""
                    rows=1
                    :auto-grow="true"
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="7">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-textarea
                    label="Kommentit/Ohjeet"
                    :value="wholesaleCompanies[selectedWholesaleCompanyId].comments"
                    @change="v => inlineSaveField(selectedWholesaleCompanyId,'comments',v)"
                    class="ml-3"
                    rows=15
                    :auto-grow="false"
                    filled
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="contacts" class="product-details-view-tab-item" >
        <!-- <v-icon 
          class="avecor-table-actions"
          style="position:absolute; top:15px;left:10px;"
          :size="16"
          @click="addContact()"
        >
          far fa-plus-square
        </v-icon> -->
        <v-row justify-center style="" class="mt-2" no-gutters>
          <v-col cols="12" class="ma-0 pa-0 text-center">
            <v-btn @click.stop="addContact()" color="#000000" dark class="avecor-button-global add-button">
              Lisää kontakti
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          v-model="selected"
          :headers="contactHeaders"
          :items="getPartnerContacts"
          :expanded.sync="expanded"
          :single-expand="singleExpand"
          :sort-by="'orderDate'"
          :sort-desc="true"
          item-key="id"
          hide-default-footer
          class="avecor-ordered-products-table"
          disable-pagination
          :options="{itemsPerPage:-1}"
          dense
          style="margin-bottom:0px !important;background:#EEE"
          fixed-header
          :height="getPartnerContacts.length > 3 ? 270 : null"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr style="max-height:15px;" class="hide-field-details">
              <td class="text-xs-center pa-1 pl-2" style="min-width:25px !important;">
                <v-icon 
                  class="avecor-table-actions"
                  size=10
                  @click="deleteContact(item.id)"
                  style="padding-left:10px;"
                >
                  far fa-trash-alt
                </v-icon>
              </td>
              <td class="minw-75 maxw-75">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.contactType"
                  :items="settings.partnerContactTypesArray"
                  @change="v => editContact(item.id, 'contactType', v)"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  class="avecor-select"
                />
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.firstName"
                  @change="v => { editContact(item.id, 'firstName', v);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.lastName"
                  @change="v => { editContact(item.id, 'lastName', v);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.phone"
                  @change="v => { editContact(item.id, 'phone', v);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-text-field
                  :value="item.email"
                  @change="v => { !emailPattern.test(v) ? showErrorSnack('Virheellinen sähköposti.') : editContact(item.id, 'email', v);}"
                  class="avecor-select hide-field-details"
                ></v-text-field>
              </td>
              <td class="text-xs-left">
                <v-autocomplete
                  autocomplete="off"
                  :value="item.role"
                  :items="settings.partnerContactRoles"
                  @change="v => editContact(item.id, 'role', v)"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  class="avecor-select"
                />
              </td>
              <td class="text-xs-left">
                <v-textarea
                  slot="input"
                  v-model="item.comments"
                  @change="v => { editContact(item.id, 'comments', v);}"
                  class="avecor-select"
                  rows=1
                  :auto-grow="autogrow"
                ></v-textarea>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'

export default {
    components: {
    },
    props: ['location'],
    data: () => ({
      emailPattern:/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      selectedWholesaleCompanyTab:'details',
      productVariationIdForNewBatch:'',
      quantityForNewBatch:'',
      unitPriceForNewBatch:'',
      expiryDateForNewBatch:'',
      statusForNewBatch:'batchOrdered',
      orderDateForNewBatch:new Date().toISOString().split('T')[0],//new Date().getFullYear()+'-'+new Date().getMonth()+'-'+new Date().getDate(),
      newBatchErrors:{
        productVariationId:'',
        quantity:'',
        unitPrice:'',
        expiryDateForNewBatch:'',
        orderDateForNewBatch:'',
      },
      dialog: false,
      showImageBar: false,
      showPreviousProductsBar: false,
      autogrow: true,
      expanded: [],
      singleExpand: true,
      selected: [],
      search: '',
      contactHeaders: [
        { text: '', value: 'number', align: 'left', sortable:false},
        { text: 'Kontaktityyppi', value: 'contactType', align: 'left', sortable:false},
        { text: 'Etunimi', value: 'firstName', align: 'left', sortable:false},
        { text: 'Sukunimi', value: 'lastName', align: 'left', sortable: false },
        { text: 'Puhelinnumero', value: 'phone', align: 'left', sortable: false },
        { text: 'Sähköposti', value: 'email', align: 'left', sortable: false },
        { text: 'Tehtävä', value: 'role', align: 'left', sortable: false },
        { text: 'Lisätiedot', value: 'comments', align: 'left', sortable: false },
      ],
    }),
    mounted() {
      
    },
    computed: {
      getPartnerContacts(){
        var contacts = []
        var wholesaleCompanies = this.wholesaleCompanies
        var selectedWholesaleCompanyId = this.selectedWholesaleCompanyId
        //console.log(this.wholesaleCompanies[this.selectedWholesaleCompanyId].partnerContacts)
        if(this.wholesaleCompanies[this.selectedWholesaleCompanyId].partnerContacts !== undefined){
          Object.keys(this.wholesaleCompanies[this.selectedWholesaleCompanyId].partnerContacts).map(contactId =>{
            contacts.push({id:contactId, ...wholesaleCompanies[selectedWholesaleCompanyId].partnerContacts[contactId]})
          })
        }
        return contacts
      },
      getWholesaleCompanies(){
        var wholesaleCompanies = this.wholesaleCompanies
        return Object.keys(this.wholesaleCompanies).map(function(key, index) {
          var c = wholesaleCompanies[key]
          return {text: c.wholesaleCode+'-'+c.name, value: c.id}
        })
      },
      selectedWholesaleCompanyId:{
        get: function () {
          if(this.location === 'partners') return this.selectedWholesaleCompanyIdInPartners
          else if(this.location === 'stock') return this.selectedWholesaleCompanyIdInWarehouse
        },
        set: function (newValue) {
          if(this.location === 'partners') this.selectedWholesaleCompanyIdInPartners = newValue
          else if(this.location === 'stock') this.selectedWholesaleCompanyIdInWarehouse = newValue
        }
      },
      ...mapFields({
        settings:"settings",
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        selectedWholesaleCompanyIdInPartners:"views.partners.selectedWholesaleCompany.wholesaleCompanyId",
        selectedWholesaleCompanyIdInWarehouse:"views.stock.selectedWholesaleCompany.wholesaleCompanyId",
        user:"user",
      }),
    },
    watch: {},
    created () {},
    methods: {
      showErrorSnack(text){
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:text, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
      },
      addBatch(){
        var errors = false
        if(!/^\d+$/.test(this.quantityForNewBatch)) {
          this.newBatchErrors.quantity = 'Syötä täysiluku'
          errors = true
        }
        if(!/^\d+(\.\d+)?$/.test(this.unitPriceForNewBatch)){
          this.newBatchErrors.unitPrice = 'Syötä luku pisteillä'
          errors = true
        } 
        if(this.productVariationIdForNewBatch === '') {
          this.newBatchErrors.productVariationId = 'Valitse variaatio'
          errors = true
        }
        if (errors) return
        else {
          var batchId1 = Math.random().toString(36).substr(2, 9);
          var batchId2 = Math.random().toString(36).substr(2, 9);
          var batchId = batchId1+batchId2
          console.log(batchId)
          this.$store.dispatch('productVariation/set', {
            id:this.productVariationIdForNewBatch,
            batches:{
              [batchId]:{
                quantity:this.quantityForNewBatch,
                unitPrice:this.unitPriceForNewBatch,
                expiryDate:this.expiryDateForNewBatch,
                orderDate:this.orderDateForNewBatch,
                status:this.statusForNewBatch,
                stockLocation:'notSet'
              }
            }
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      addContact(){
        var contactId1 = Math.random().toString(36).substr(2, 9);
        var contactId2 = Math.random().toString(36).substr(2, 9);
        var contactId = contactId1+contactId2
        this.$store.dispatch('wholesaleCompany/set', {
          id:this.selectedWholesaleCompanyId,
          partnerContacts:{
            [contactId]:{
              firstName:"",
              lastName:"",
              phone:"",
              email:"",
              type:"",
              role:"notSelected",
              comments:""
            }
          }
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      deleteContact(contactId){
        var id = this.selectedWholesaleCompanyId
        var partnerContacts = this.wholesaleCompanies[id].partnerContacts
        if (confirm('Haluatko poistaa?')) {
          delete partnerContacts[contactId]

          this.$store.dispatch('wholesaleCompany/delete', `${id}.partnerContacts.${contactId}`)
          this.$store.dispatch('wholesaleCompany/set', {
            id,
            partnerContacts
          }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      editContact(id,field,value){
        var partnerContacts = this.wholesaleCompanies[this.selectedWholesaleCompanyId].partnerContacts
        partnerContacts[id][field] = value
        this.$store.dispatch('wholesaleCompany/set', {
          id:this.selectedWholesaleCompanyId,
          partnerContacts
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      inlineSaveField (id,field,value) {
        this.$store.dispatch('wholesaleCompany/set', {
          id,
          [field]:value
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:1500, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/blocks/WholesaleCompanyExpand.vue